import React from 'react'
import '../../App.scss';

const Footer = () => {
  return (
    <div className="copyright">
    <p className="p-text">@2023 Md Akeel</p>
    <p className="p-text">All rights reserved</p>
  </div>
  )
}

export default Footer